export class ListMongoAtlasPrivateLinks200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entries",
            "baseName": "entries",
            "type": "Array<MongoAtlasPrivateLinkEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMongoAtlasPrivateLinks200Response.attributeTypeMap;
    }
    constructor() {
    }
}
